import React from "react";
import { format, fromUnixTime } from "date-fns";
import { ViewStyle } from "react-native";
import {
  Bubble,
  BubbleProps,
  LeftRightStyle,
  utils,
} from "react-native-gifted-chat";
import GiftedChatName from "./GiftedChatName";
import areMessagesSameDay from "./areMessagesSameDay";
import { FormattedChatMessage } from "../../app/types";

const GiftedChatBubble = (props: BubbleProps<FormattedChatMessage>) => {
  const { currentMessage, previousMessage } = props;

  if (!currentMessage) {
    return null;
  }

  const isSame =
    utils.isSameUser(currentMessage, previousMessage) &&
    areMessagesSameDay(currentMessage, previousMessage);

  return (
    <div className="wrapper">
      {isSame || (
        <div className="info">
          <GiftedChatName name={currentMessage.user.name} />
          <span>
            {format(fromUnixTime(currentMessage.createdAt), "h:mm aa")}
          </span>
        </div>
      )}
      <Bubble
        {...props}
        bottomContainerStyle={bottomContainerStyle}
        containerStyle={containerStyle}
        wrapperStyle={isSame ? wrapperStyle : undefined}
      />
      <style jsx>{`
        span {
          color: grey;
          padding: 2px 0 0 5px;
          font-size: 0.7rem;
        }
        .wrapper {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
        }
        .info {
          display: flex;
          flex-direction: row;
          align-items: center;
        }
      `}</style>
    </div>
  );
};

const bottomContainerStyle: LeftRightStyle<ViewStyle> = {
  left: { display: "none" },
  right: { display: "none" },
};

const containerStyle: LeftRightStyle<ViewStyle> = {
  left: {
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    marginLeft: 0,
    marginRight: 0,
  },
  right: {
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "flex-end",
    marginLeft: 0,
    marginRight: 0,
  },
};

const wrapperStyle: LeftRightStyle<ViewStyle> = {
  left: {
    backgroundColor: "transparent",
    marginLeft: 0,
    marginRight: 10,
    minHeight: 20,
    justifyContent: "flex-start",
  },
  right: {
    backgroundColor: "transparent",
    marginLeft: 0,
    marginRight: 10,
    minHeight: 20,
    justifyContent: "flex-start",
  },
};

export default GiftedChatBubble;
